













































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'
import moment from 'moment'
import {Responsavel} from '@/model/resource/Responsavel'
import {InputResponsavelSchema} from '@/schema/resource/Responsavel/InputResponsavelSchema'

@Component
export default class ModalUpdateExpiringDate extends Vue {
  model = new Responsavel()
  schema = new InputResponsavelSchema()

  openEvent(id?: number) {
    this.$emit('open')

    if (id) {
      this.model.getResponsavel(id)
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.model.reset()
    this.$emit('close')
  }

  validate(date: string | null) {
    const d = moment(date ?? '')
    return moment(d).isValid()
  }

  async confirmEvent() {
    if (this.model.dataVencimento == null) {
      Helper.abort('system.error.emptyDataVencimento')
    }

    if (!this.validate(this.model.dataVencimento)) {
      Helper.abort('system.error.invalidDataVencimento')
    }

    await this.model.updateDataVencimento(this.model.dataVencimento ?? '')
    await Helper.success('system.success.persist')
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('updateExpiringDate')
    this.$tip.hideAll()
  }
}
